import React, { useState } from 'react'
import copyToClipboard from 'copy-to-clipboard'
import CopyTextIcon from 'client/icons/CopyText'
import SuccessFilledIcon from 'client/icons/SuccessFilled'
import styles from './styles.module.css'
import { useIntl } from 'react-intl'
import { Tooltip } from 'src/comps/Molecules/Tooltip'

interface CopyTextProps {
  children: string
}

const CopyText = ({ children }: CopyTextProps) => {
  const intl = useIntl()
  const [copied, setCopied] = useState(false)

  function handleClick() {
    copyToClipboard(children)
    setCopied(true)
    setTimeout(() => setCopied(false), 3000)
  }

  return (
    <span className={styles.container}>
      {children}{' '}
      <button type="button" data-testid="copy-text" className={styles.button} onClick={handleClick}>
        {copied ? <SuccessFilledIcon size={24} /> : <CopyTextIcon size={24} />}
        <Tooltip
          message={intl.formatMessage({
            id: copied ? 'global.copied' : 'global.copy',
          })}
          align="center"
        />
      </button>
    </span>
  )
}

export default CopyText
